/**
 * خريطة الموقع — مصدر واحد للقائمة والمسارات.
 *
 * كانت القائمة تحمل مراسي ثابتة: ‎#academy و‎#services و‎#features، مكتوبة
 * داخل Nav.jsx بمعزل عن الصفحة التي تحتوي تلك الأقسام. أي تغيير في بنية
 * الصفحة الرئيسية كان يكسر القائمة صامتًا — ولا شيء يربط الطرفين ليكشف ذلك.
 *
 * وهذا ما حدث فعلًا عند إعادة بناء الصفحة الرئيسية: ثلاثة من أربعة روابط
 * صارت تشير إلى أقسام لم تعد موجودة.
 *
 * صفحات حقيقية أفضل من مراسٍ لأسباب عملية: العنوان قابل للمشاركة، والرجوع
 * للخلف يعمل كما يتوقع المستخدم، ولكل صفحة عنوان ووصف مستقل لمحركات البحث.
 *
 * القائمة والمسارات تُبنى الآن من هذا الملف، فلا يمكن أن يفترقا.
 */

export const NAV_LINKS = [
  { path: '/',            label: 'الرئيسية' },
  { path: '/about',       label: 'عن الأكاديمية' },
  { path: '/programs',    label: 'البرامج والمواد' },
  { path: '/accreditation', label: 'الشهادات والاعتماد' },
  { path: '/contact',     label: 'تواصل معنا' },
];

/** عناوين ووصف كل صفحة — تُستخدم في <title> ووسوم الوصف. */
export const PAGE_META = {
  '/': {
    title: 'أكاديمية الرواد ابن سينا | تدريب معتمد لمساعدي الخدمات الصحية',
    description:
      'أكاديمية الرواد ابن سينا بطنطا — برامج تدريب معتمدة لمساعدي الخدمات الصحية، بتدريب نظري وعملي داخل المستشفيات وشهادات قابلة للتوثيق.',
  },
  '/about': {
    title: 'عن الأكاديمية | الرواد ابن سينا',
    description:
      'من نحن، وما يميّز التدريب في أكاديمية الرواد ابن سينا: اعتماد من ثلاث جهات حكومية، وتدريب ميداني، ومعامل مجهّزة.',
  },
  '/programs': {
    title: 'البرامج والمواد الدراسية | الرواد ابن سينا',
    description:
      'البرنامج المكثّف سنة واحدة والبرنامج العادي سنتان، والمواد التخصصية الثماني التي تُدرَّس في الأكاديمية.',
  },
  '/accreditation': {
    title: 'الشهادات والاعتماد | الرواد ابن سينا',
    description:
      'شهادة مختومة بشعار الجمهورية وقابلة للتوثيق، وكارنيه مزاولة المهنة من وزارة العمل، وتعديل المسمّى الوظيفي.',
  },
  '/contact': {
    title: 'تواصل معنا | الرواد ابن سينا',
    description:
      'مقر الأكاديمية أمام جامعة طنطا، وأرقام التواصل ومواعيد الرد.',
  },
  '/SingUP': {
    title: 'تسجيل بيانات الالتحاق | الرواد ابن سينا',
    description: 'سجّل بياناتك ويتواصل معك فريق الأكاديمية لشرح البرامج وشروط الالتحاق.',
  },
};
